export const MOCK_LEAKED_HOSTS_RESPONSE = {
  count: 2,
  total_pages: 1,
  current_page: 1,
  results: [
    { id: 'mock-leaked-host-1', host: 'example.com', count: 12, last_seen: '2024-01-15' },
    { id: 'mock-leaked-host-2', host: 'acme.io', count: 5, last_seen: '2024-01-10' },
  ],
}

export const MOCK_LEAKED_HOST_DETAIL = {
  count: 3,
  total_pages: 1,
  current_page: 1,
  results: [
    {
      id: 'mock-leaked-1',
      email: 'admin@example.com',
      username: 'admin',
      password: '••••••••',
      source: 'DataBreach2024',
      categories: ['credentials'],
    },
    {
      id: 'mock-leaked-2',
      email: 'info@example.com',
      username: 'info',
      password: '••••••••',
      source: 'ComboList2023',
      categories: ['credentials'],
    },
  ],
}
